<template>
  <v-dialog persistent v-model="show" max-width="700px">
    <v-card flat>
      <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>

      <h2>{{ $t('login.password.forgot-password') }}</h2>
      <v-card-text class="pl-0 pr-0"> {{ $t('login.password.sms-sent') }} {{ getLastPhoneNumbers() }}. </v-card-text>
      <div>
        <v-form ref="form">
          <v-text-field
            outlined
            :label="$t('login.password.sms-code')"
            v-model="smsCode"
            :rules="[rules.required, rules.integer, rules.confirmCode]"
            :error-messages="error"
            @input="clearErrorMessages"
          />
          <v-card-text class="pa-0"> {{ $t('login.password.delivery-info') }} </v-card-text>

          <ActionButton class="mt-4" actionIcon="$sl-mobile" @click="requestSMScode" :isDisabled="timeLeft > 0">{{
            $t('login.password.resend-code')
          }}</ActionButton>
          <p v-show="timeLeft > 0" class="pa-0 pt-1 asterisk">
            {{ $t('login.password.order-countdown', {time: timeLeft}) }}
          </p>
          <div v-if="smsError" class="v-messages v-messages__message error--text">
            {{ $t(smsError) }}
          </div>
          <ActionButton class="mt-4" actionIcon="$sl-password-type" @click="validateSmsCode">{{
            $t('login.password.create-new-password')
          }}</ActionButton>
        </v-form>
        <ActionButton class="mt-4" actionIcon="$sl-cancel" type="application" @click="$emit('close')">{{
          $t('labels.cancel')
        }}</ActionButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import {RulesMixin} from '@/components/mixins'
import ActionButton from '@/components/Common/ActionButton'

export default {
  name: 'SmsCodeModal',

  mixins: [RulesMixin],

  props: {
    show: false,
    mobilephone: '',
    lastSms: null
  },

  data: () => ({
    smsCode: '',
    timeLeft: 0,
    error: '',
    smsError: ''
  }),

  components: {
    ActionButton
  },
  watch: {
    lastSms: {
      handler(value, oldValue) {
        if (value && value !== oldValue) {
          this.timeLeft = 120
          setTimeout(this.countdown, 1000)
        }
      }
    }
  },
  methods: {
    getLastPhoneNumbers() {
      return this.mobilephone.substr(this.mobilephone.length - 2)
    },
    requestSMScode() {
      API.requestSMScode({mobilephone: this.mobilephone})
        .then(result => {
          this.$emit('sendSms', new Date())
        })
        .catch(() => {
          this.smsError = this.$t('login.password.error-on-sms-send')
        })
    },
    countdown() {
      if (this.timeLeft > 0) {
        this.timeLeft -= 1
        setTimeout(this.countdown, 1000)
      }
    },
    validateSmsCode() {
      const valid = this.$refs.form.validate()
      if (!valid) return

      API.validateSMScode({mobilephone: this.mobilephone, code: this.smsCode})
        .then(({data}) => {
          this.$emit('close', data)
        })
        .catch(error => {
          this.error = this.$t('login.password.invalid-sms-code')
        })
    },
    clearErrorMessages() {
      this.error = ''
    }
  }
}
</script>

